import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { useId } from 'react';

import { cn } from '@utils/index';

interface CheckboxProps
  extends React.ComponentProps<typeof CheckboxPrimitive.Root> {
  label?: string;
  labelProps?: React.HTMLAttributes<HTMLSpanElement>;
}

function Checkbox({ className, label, labelProps, ...props }: CheckboxProps) {
  const { className: labelClassName, ...restLabelProps } = labelProps || {};

  return (
    <label className="flex flex-row xl:gap-3 gap-1.5 items-center cursor-pointer mb-auto">
      <CheckboxPrimitive.Root
        data-slot="checkbox"
        className={cn(
          'peer self-start size-6 xl:size-8 mt-1 shrink-0 rounded-[4px] border border-[var(--color-border-select)] data-[state=checked]:border-primary data-[state=unchecked]:bg-white data-[state=checked]:bg-primary focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 outline-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none"
        >
          <CheckIcon className="size-6 xl:size-8 text-white" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>

      {label && (
        <span
          className={cn(
            'text-base !cursor-pointer',
            labelClassName
          )}
          {...restLabelProps}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
    </label>
  );
}

export { Checkbox };
